var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{ref:"rootRef",staticClass:"suus__html-text",class:`mb-0 ${_vm.customClass}`,style:(_vm.htmlStyles),domProps:{"innerHTML":_vm._s(_vm.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }